/**
 * The moments a live lesson changes by the clock alone: its call opens (windowOpenAt, else 10 minutes before
 * the start) and its window ends (windowCloseAt, else 15 minutes after the lesson). The rows and the lesson
 * page re-read the clock only then, with one timeout for the soonest (Ryan, 30 Oct: no polling).
 */
const MIN = 60_000;
/** setTimeout's largest delay; a later boundary is waited for in steps of this. */
export const MAX_DELAY = 2_147_483_647;

export interface ClockLesson { scheduledStartAt: string; windowOpenAt?: string | null; windowCloseAt?: string | null; durationMinutes?: number | null }

export function lessonBoundaries(b: ClockLesson): number[] {
  const start = Date.parse(b.scheduledStartAt);
  const open = b.windowOpenAt ? Date.parse(b.windowOpenAt) : start - 10 * MIN;
  // The call closes 15 minutes after the scheduled end (decision 53), whatever the server's room window says.
  const close = start + ((b.durationMinutes ?? 45) + 15) * MIN;
  return [open, close].filter((t) => !Number.isNaN(t));
}

/** The soonest boundary after now among the lessons, or null when none is ahead. */
export function nextBoundary(lessons: ClockLesson[], nowMs: number): number | null {
  let next: number | null = null;
  for (const b of lessons) for (const t of lessonBoundaries(b)) if (t > nowMs && (next === null || t < next)) next = t;
  return next;
}

/** What the timeout waits for the next boundary, a little past it so the boundary is behind the clock. */
export function delayTo(next: number, nowMs: number): number {
  return Math.min(Math.max(0, next - nowMs) + 50, MAX_DELAY);
}
